<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-analysis/modelList' }"
              >模型管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>模型配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form ref="myForm" :model="formData" :label-width="formLabelWidth">
          <el-form-item label="模型名称:" prop="pattern_name">
            <div>{{ formData.pattern_name }}</div>
          </el-form-item>

          <el-form-item label="模型区域类型:" prop="pattern_area_type">
            <div>{{ formData.pattern_area_type | getAreaTypeName }}</div>
          </el-form-item>

          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">配置中主体:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <zv-table :table="table" ref="dataTable">
                <div slot="ctrl-button">
                  <el-button type="primary" @click="doAdd">新增主体</el-button>
                </div>
              </zv-table>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="复制"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <!-- @change="areaSelectChange" -->
      <span>主体（{{formData.pattern_area_type | getAreaTypeName}}）：</span>
      <el-select
        v-model="to_area_id"
        filterable
        clearable
      >
        <el-option
          v-for="item in areaData"
          :key="item.id"
          :label="item.full_area_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import enums from "@/utils/enums";
import EventBus from "@/utils/services/event_service";

export default {
  name: "ConfigModel",
  mixins: [formPageMixin, addFormMixin],
  components: {},
  data() {
    let vm = this;
    return {
      dialogVisible: false,
      countryTurn: "",
      areaData: [],
      to_area_id: "",
      objRow: [],
      id: "", // 事件编辑时id
      formData: {
        pattern_name: "", // 模型名字
        pattern_area_type: "", // 针对类型 1通用 2华人
        target_type: "", // 模型可适用范围 2 国 3省 4市
        patter_reduce_arr: [], //
        // 模型计算事件影响范围 0 全球性 1 洲 2 国 3省（州） 4市 设置多个用,隔开
        pattern_calc_event_affect_area_type: "",
        // 模型计算事件影响范围 结果衰减值（打折） 取值范围0~1 设置多个用,隔开
        pattern_calc_event_affect_area_reduce: "",
        pattern_item_id: "" // 模型包含的模块id 设置多个用,隔开
      },
      table: {
        api: api.modelMainList,
        query: {
          pattern_id: vm.$route.query.id
        },
        searchData: [
          {
            type: "input",
            model: "q",
            placeholder: "输入关键字"
          }
        ],
        hidePagination: false,
        autoHeight: true,
        columns: [
          {
            title: "主体名称",
            key: "area_name",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth: "150",
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "最后修改时间",
            key: "update_time",
            minWidth: "150",
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.update_time));
            }
          },
          {
            title: "开启状态",
            key: "status",
            minWidth: "150",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: parseInt(ctx.row.status),
                  "inactive-value": 0,
                  "active-value": 1
                  // "inactive-text": "关闭",
                  // "active-text": "开启"
                },
                on: {
                  change(status) {
                    vm.doChangeStatus(
                      status,
                      ctx.row.pattern_id,
                      ctx.row.area_id
                    );
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "150",
            render(h, ctx) {
              const copyBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doCopy.bind(this, ctx.row)
                  }
                },
                "复制"
              );

              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row.area_id)
                  }
                },
                "编辑"
              );

              const InterveneBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    style: ctx.row.overwrite ? "color: red":""
                  },
                  on: {
                    click: vm.doIntervene.bind(this, ctx.row.area_id)
                  }
                },
                "干预"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.specialDoDelete.bind(this, ctx.row)
                  }
                },
                "删除"
              );

              let arr = [];
              if(vm.formData.pattern_area_type != 2) {
                arr.push(copyBtn);
              }
              arr.push(InterveneBtn);
              arr.push(editBtn);
              arr.push(delBtn);
              return h("span", arr);
            }
          }
        ]
      },
      deleteApi: api.deleteModelItem,
      deleteSuccessMsg: "删除模型主体成功"
    };
  },
  computed: {},

  methods: {
    initCommonData() {
      this.getModelInfo();
    },

    async getModelInfo() {
      let resData = await api.modelDetail({
        id: this.id
      });
      this.formData = resData.info;
    },

    doAdd() {
      this.$router.push(this.getConfigMainUrl());
    },

    doEdit(area_id) {
      let routeData = this.$router.resolve(this.getConfigMainUrl(area_id));
      window.open(routeData.href, '_blank');
    },

    // laftiewu => 4.22 干预事件
    doIntervene(area_id) {
      let routeData = this.$router.resolve(this.getConfigMainUrl2(area_id));
      window.open(routeData.href, '_blank');
    },

    getConfigMainUrl(area_id) {
      let commonUrl = `/data-analysis/configModelMain?pattern_id=${this.id}&area_type=${this.formData.pattern_area_type}`
      if (area_id) {
        commonUrl += "&area_id=" + area_id
      }

      return commonUrl
    },

    getConfigMainUrl2(area_id) {
      let commonUrl = `/data-analysis/ConfigModelIntervene?pattern_id=${this.id}&area_type=${this.formData.pattern_area_type}`
      if (area_id) {
        commonUrl += "&area_id=" + area_id
      }

      return commonUrl
    },

    // 2020.04.17新增复制
    async doCopy(row) {
      this.to_area_id = ""
      this.objRow = row
      this.dialogVisible = true
      let res = await api.areaList(
        {
          area_type: this.formData.pattern_area_type,
          parent_area_id: row.parent_area_id,
          page: 1,
          pagesize: 9999
        }
      ).then(res => {
        this.areaData = res.list
      })
      this.$commFunc.getAreaList().then(res => {
        this.areaData = res
        console.log(res)
      })
    },

    // 复制提交
    async dialogSave() {
      const {
        pattern_id,
        area_id
      } = this.objRow
      await api.adminAreaCopy({
        pattern_id,
        from_area_id:area_id,
        to_area_id: this.to_area_id
      });
      this.dialogVisible = false
      this.$refs.dataTable.refresh();
      this.$message.success("复制完成!");
    },

    // 删除
    async specialDoDelete(row) {
      this.$confirm(
        '确定删除该条记录？',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteApi({
          area_id: row.area_id,
          pattern_id: row.pattern_id
        })
        this.$nextTick(function () {
          this.$refs.dataTable.refresh();
          this.$message.success("删除成功!");
        })
        
      }).catch(() => {
      });
    },

    async doChangeStatus(status, pattern_id, area_id) {
      await api.modelMainStatusChange({
        pattern_id,
        area_id,
        status: status
      });
      this.$refs.dataTable.refresh();
      this.$message.success("状态修改成功!");
    }
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.id = parseInt(id);
    }
    this.initCommonData();
  },
  mounted() {},
  beforeDestroy() {},
  filters: {
    getAreaTypeName(areaId) {
      return enums.AreaType.getForModeName(areaId);
    }
  }
};
</script>

<style lang="less" scoped></style>
